var kind          = require("enyo/kind"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get;

require("./MetadataListItem.less");

module.exports = kind(/** @lends  app.ui.header.MetadataListItem.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.MetadataListItem",

    /**
     * @private
     */
    classes: "app-ui-header-metadata-list-item",

    /**
     * @private
     */
    tag: "tr",


    /**
     * @private
     */
    components: [{
        name:    "label",
        tag:     "th",
        classes: "app-ui-header-metadata-list-item__label"
    }, {
        name:    "value",
        tag:     "td",
        classes: "app-ui-header-metadata-list-item__value"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var data = this.data || {};

        this.$.label.set("content", get(data, "label", null) || "");
        this.$.value.set("content", get(data, "value", null) || "");
    }

});
